import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const grnFiltersGet = async (signal, options) => {
  const resourcePath = `${Constants.PATH.GRN.filters}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnListGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.GRN.list}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnSummaryGet = async (params, signal, options) => {
  const resourcePath = `${Constants.PATH.GRN.summary}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params,
      data: options,
      options,
      signal
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// po search in create flow
const grnFacilitiesGet = async (poId, options) => {
  const resourcePath = `${Constants.PATH.GRN.facilities}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { poId },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// grn edit flow
const grnIdDetailsGet = async (poId, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${poId}${Constants.PATH.GRN.details}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdUpdatePut = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.update}`;

  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnPost = async (data, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnSkuSampleGet = async (options) => {
  const resourcePath = `${Constants.PATH.GRN.skuSample}`;

  try {
    const res = await api_request({ methodType: 'get', resourcePath, options });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdSkuValidatePost = async (id, file, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.validateSKU}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

// file submit
const grnIdFilesSubmitPost = async (data, id, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.filesSubmit}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      data,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdCommentsUploadPost = async (remarks, comment_type, id, file, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.commentsUpload}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { remarks, comment_type },
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdFilesUpdatePut = async (payload, id, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.filesUpdate}`;

  try {
    const res = await api_request({
      methodType: 'put',
      resourcePath,
      params: { id },
      data: { ...payload },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdRequiredFilesGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.requiredFiles}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const grnIdExcessSkuFileGet = async (id, options) => {
  const resourcePath = `${Constants.PATH.GRN.grn}/${id}${Constants.PATH.GRN.excessSkuFile}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  grnFiltersGet,
  grnListGet,
  grnSummaryGet,
  grnFacilitiesGet,
  grnIdDetailsGet,
  grnIdUpdatePut,
  grnPost,
  grnSkuSampleGet,
  grnIdSkuValidatePost,
  grnIdFilesSubmitPost,
  grnIdCommentsUploadPost,
  grnIdFilesUpdatePut,
  grnIdRequiredFilesGet,
  grnIdExcessSkuFileGet
};
